import React from "react";
import ThemeContext from "./ThemeContext";
import { HashRouter } from "react-router-dom";
import { MapViewProvider } from "./MapViewContext";
import { CityProvider } from "./CityContext";
import LeftPanelVisibleProvider from "./LeftPanelVisibleContext";
import { EvaluatorProvider } from "./EvaluatorContext";
import CityProfileVisibleProvider from "./CityProfileVisibleContext";
import { ParkProvider } from "./ParkContext";
import AlignmentProvider from "./AlignmentContext";
import CompareProvider from "./CompareContext";
import LeftPanelProvider from "./LeftPanelContext";
import PrioritizeSlidersProvider from "./PrioritizeSlidersContext";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeContext>
      <HashRouter>
        <PrioritizeSlidersProvider>
          <CompareProvider>
            <AlignmentProvider>
              <CityProfileVisibleProvider>
                <ParkProvider>
                  <LeftPanelVisibleProvider>
                    <EvaluatorProvider>
                      <LeftPanelProvider>
                        <MapViewProvider>
                          <CityProvider>{children}</CityProvider>
                        </MapViewProvider>
                      </LeftPanelProvider>
                    </EvaluatorProvider>
                  </LeftPanelVisibleProvider>
                </ParkProvider>
              </CityProfileVisibleProvider>
            </AlignmentProvider>
          </CompareProvider>
        </PrioritizeSlidersProvider>
      </HashRouter>
    </ThemeContext>
  );
};

export default Providers;
